import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  DoCheck,
  KeyValueDiffers
} from "@angular/core";
import { Polygon, Stroke } from "../../types";
import { isNullOrUndefined } from "util";
import { SvgHelper } from "../../helpers/svghelper.service";

@Component({
  selector: "g[svg-polygon]",
  templateUrl: "./svgpolygon.component.html",
  styleUrls: ["./svgpolygon.component.css"]
})
export class SvgPolygonComponent implements OnInit, DoCheck {
  differ: any;

  constructor(private differs: KeyValueDiffers, private svghelper: SvgHelper) {
    this.differ = this.differs.find({}).create();
  }

  @Input()
  public pointsString;

  @Input()
  public polygon: Polygon;

  @Output()
  public polygonMousedown = new EventEmitter<{
    mouseEvent: MouseEvent;
    polygon: Polygon;
  }>();

  @Output()
  public polygonMouseover = new EventEmitter<{
    mouseEvent: MouseEvent;
    polygon: Polygon;
  }>();

  ngOnInit() {
    if (this.polygon && isNullOrUndefined(this.pointsString)) {
      this.pointsString = this.svghelper.getPolyPoints(this.polygon.vertices);
    }
    if (!this.polygon.stroke) {
      this.polygon.stroke = new Stroke();
    }
  }

  ngDoCheck() {
    const changes = this.differ.diff(this.polygon);

    if (changes) {
      this.pointsString = this.svghelper.getPolyPoints(this.polygon.vertices);
    }
  }

  public onPolygonMouseDown($event: any): void {
    if ($event) {
      this.polygonMousedown.emit({ mouseEvent: $event, polygon: this.polygon });
    }
  }

  public onPolygonMouseOver($event: any): void {
    if ($event) {
      this.polygonMouseover.emit({ mouseEvent: $event, polygon: this.polygon });
    }
  }
}
